import { IAlertInfo } from "../../Models/Comments/Alerts";

// Get the 'bottom' alert item info based on the specified set of ids (alertIds)
export function bottomLevelAlertInfoFromIds(alertIds: number[], alertOptionsHeirarchy: IAlertInfo[]): IAlertInfo[]
{
    const items = alertIds
        .filter(alertId => !alertOptionsHeirarchy.find(opt => opt.id === alertId))
        .map(alertId => getAlertInfoById(alertId, alertOptionsHeirarchy))
        .filter(item => item);
    return items as IAlertInfo[];
}

// Get the alert option based on the specified ID
function getAlertInfoById(alertId: number, alertOptionsHeirarchy: IAlertInfo[]): IAlertInfo |undefined {
    if (!alertOptionsHeirarchy)
        return;

    for(const option of alertOptionsHeirarchy)
    {
        if (option.id === alertId)
            return option;

        for(const childOption of option.children ?? [])
        {
            if (childOption.id === alertId)
                return childOption;
        }
    }
}
